import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hitechnursery',
  templateUrl: './hitechnursery.component.html',
  styleUrls: ['./hitechnursery.component.css']
})
export class HitechnurseryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
